import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { flow } from 'lodash-es';
import { connect } from 'react-redux';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { EngagementHandler } from 'client/engagement-handlers';
import { ListEngagementHandler } from 'client/engagement-handlers/list-engagement-handler/list-engagement-handler';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { LeaseDealsModel, LeaseDealsPaths } from 'client/data/models/lease-deals';
import {
  MOBILE_IMAGE_WIDTH,
  DESKTOP_IMAGE_WIDTH,
} from 'client/site-modules/lease-deals/constants/lease-deals-constants';
import { getLeaseDealsTrackingData } from 'client/site-modules/lease-deals/utils/get-lease-deals-tracking-data';
import { getLeaseDealsDataWithPhotos } from 'client/site-modules/lease-deals/utils/get-lease-deals-data-with-photos';
import { LeaseDealsEntities } from 'client/site-modules/lease-deals/constants/prop-types';
import { getListTrackingCreativeId } from 'site-modules/lease-deals/utils/get-list-tracking-creative-id';

EngagementHandler.register(ListEngagementHandler);

export const withLeaseDealsListTracking = WrappedComponent => {
  function LeaseDealsListTracking({
    leaseDealsData = undefined,
    photos = undefined,
    selectedFilters = undefined,
    ...rest
  }) {
    useEffect(() => {
      if (!leaseDealsData || !photos) {
        return;
      }

      const trackingData = flow(getLeaseDealsDataWithPhotos, getLeaseDealsTrackingData)(leaseDealsData, photos);

      EventToolbox.fireCustomEvent(TrackingConstant.ACTION_LIST_VIEWED, {
        extendObj: trackingData,
        creativeId: getListTrackingCreativeId(selectedFilters),
      });
      // eslint-disable-next-line
    }, [leaseDealsData, photos]);

    return <WrappedComponent {...rest} />;
  }

  LeaseDealsListTracking.displayName = `LeaseDealsListTracking(${
    WrappedComponent.displayName || WrappedComponent.name
  })`;

  LeaseDealsListTracking.propTypes = {
    leaseDealsData: LeaseDealsEntities.LeaseDealsData,
    photos: PropTypes.arrayOf(PropTypes.shape({})),
    selectedFilters: PropTypes.shape({}),
    withPreviewCard: PropTypes.bool,
  };

  const mapStateToProps = state => ({ isMobile: state.mobile });
  const stateToPropsConfig = {
    leaseDealsData: bindToPath(LeaseDealsPaths.getLeaseDealsPath(), LeaseDealsModel, null, false),
    photos: bindToPath(
      ({ isMobile }) => LeaseDealsPaths.getPhotosPath(isMobile ? MOBILE_IMAGE_WIDTH : DESKTOP_IMAGE_WIDTH),
      LeaseDealsModel,
      null,
      false
    ),
    selectedFilters: bindToPath(LeaseDealsPaths.getSelectedFiltersPath(), LeaseDealsModel, null, false),
  };

  return connect(mapStateToProps)(connectToModel(LeaseDealsListTracking, stateToPropsConfig));
};
